@if (loadingState$ | async; as loadingState) {
  <div class="map-container">
    @if (loadingState.hasLoaded) {
      <app-map
        class="span-progress-map"
        [layers]="getLayers()"
        [overlay]="getOverlayLayers()"
        [mapBounds]="getMapBounds()!"
        [version]="getVersion()"
        [activeSidePanel]="activeSidePanel"
        (geolocationDenied)="onGeolocationDenied()"
        (mapReady)="onMapReady()"
        (sidePanelSelected)="setActiveSidePanel($event)"
        [@mapResize]="activeSidePanel ? 'resize' : 'full'"
      ></app-map>
    }
    @if (!isSelectSpanMode()) {}
    @if (activeSidePanel === 'ducts') {
      <div class="duct-menu" @menuInOut>
        <app-duct-table
          class="duct-table"
          (closeSidePanel)="onSidePanelClose()"
        />
      </div>
    }
    @if (activeSidePanel === 'reports') {
      <div class="reports-menu" @menuInOut>
        <app-reports-panel
          class="reports-panel"
          (closeSidePanel)="onSidePanelClose()"
        />
      </div>
    }
    <div class="parent-container">
      @if (loadingState.isLoading) {
        <ipo-loading-spinner></ipo-loading-spinner>
      }
      @if (loadingState.hasError) {
        <ipo-alert class="error-message" type="danger">
          {{ 'mapDataError' | translate }}<br />
          {{ getFetchErrors(loadingState.errors) }}
        </ipo-alert>
      }
      @if (!(selectedResource$ | async)) {
        <div class="no-active-project-wrapper">
          {{ 'noResourceSelected' | translate }}
        </div>
      }
    </div>
    @if (showLocationModal) {
      <ipo-modal
        [confirmable]="true"
        [closeable]="false"
        [proceedString]="'geolocation.proceedButton' | translate"
        [buttonSize]="'large'"
        (proceed)="closeLocationModal()"
        (dismiss)="closeLocationModal()"
      >
        <p class="modal-content">{{ 'geolocation.text' | translate }}</p>
      </ipo-modal>
    }
    @if (loadingState.hasLoaded) {
      <app-span-progress-report></app-span-progress-report>
    }
    @if (isSelectSpanMode()) {
      <app-select-span-mode />
    }
  </div>
}

@if (!(modalState$ | async)?.installationReportModalV2?.open) {
  <app-feedback-alert />
  <app-detailed-error-feedback-alert />
}
